<template>
  <b-row v-if="!isLoading" class="justify-content-md-center m-0">
    <b-col lg="8">
      <base-bread-crumb :items="breadcrumbs" class="bg-white" />

      <learning-unit-header
        v-if="learningUnit"
        :learning-unit="learningUnit"
        :show-alert-review="$currentUser.isOwnerOf(learningUnit.id)"
      >
        <div class="d-flex align-items-center">
          <submit-review-button
            v-if="
              isMode === 'instructor' &&
              $currentUser.isOwnerOf(learningUnit.id) &&
              !learningUnit.is_published
            "
            :learning-unit="learningUnit"
            :todos="todos"
            :conflicts="conflicts"
          ></submit-review-button>

          <approve-or-edit-button
            v-if="
              isMode === 'reviewer' &&
              $currentUser.isReviewer() &&
              (learningUnit.is_published || learningUnit.required_review)
            "
            :learning-unit="learningUnit"
            class="ml-3"
            @confirmed="fetch"
          ></approve-or-edit-button>
        </div>
      </learning-unit-header>

      <b-alert
        v-if="
          $currentUser.isOwnerOf(learningUnit.id) &&
          learningUnit &&
          learningUnit.latest_request_changes_at &&
          !learningUnit.is_published
        "
        show
        variant="warning"
      >
        <span class="mr-3">
          <font-awesome-icon icon="circle-exclamation" size="xl" />
        </span>
        <span>Reviewer request for changes, please adjust accordingly.</span>
      </b-alert>

      <!-- <ultimate-learning-outcome
        v-if="learningUnit"
        class="mb-5 mt-3"
        :learningUnit="learningUnit"
        :disabled="disabled || learningUnit.is_published"
      /> -->

      <div v-if="learningUnit" class="mb-5">
        <div ref="text__compentency-title" class="text__compentency-title mb-2">
          <b>Competency</b>
        </div>

        <base-text-editor-display>
          <div
            ref="text__compentency-description"
            v-safe-html="learningUnit.competency_detail"
            class="text__compentency-description text-pre-line"
          ></div>
        </base-text-editor-display>
      </div>

      <b-tabs
        v-if="learningUnit"
        v-model="activeTab"
        lazy
        pills
        nav-class="nav-line nav-line-alt"
        content-class="pt-4"
        @activate-tab="onActivateTab"
      >
        <!-- tab-basic-info -->
        <PageBasicInfo
          :disabled="disabled"
          :editable="editable"
          :mode="isMode"
          :has-method-component="hasMethodComponent"
        />

        <!-- tab-evaluation-assessment -->
        <tab-evaluation-assessment
          :learning-unit="learningUnit"
          :disabled="disabled"
          :active="isTabActive('evaluation-assessments')"
        />

        <!-- tab-learning -->
        <PageSection
          :learning-unit="learningUnit"
          :disabled="disabled"
          :mode="isMode"
          @emitDeleteEvent="fetch"
        />

        <!-- tab-submission-dashboard -->
        <tab-assess
          v-if="isOwner"
          ref="tab-assess__owner"
          :title="'Submission dashboard'"
          :active="isTabActive('submission-dashboard')"
          mode="owner"
        />

        <!-- tab-assessor -->
        <PageInstructor :learning-unit="learningUnit" :disabled="disabled" />

        <!-- tab-assign-assessor -->
        <tab-assign-assessor v-if="isOwner" :active="isTabActive('assign-assessor')" />

        <!-- tab-assess -->
        <!-- <tab-assess
          v-if="isAssessor || isOwner"
          ref="tab-assess__assessor"
          :title="'Assess'"
          :assessor-id="this.$currentUser.id"
          :active="isTabActive('assess')"
        /> -->

        <!-- tab-competency -->
        <!-- <tab-learning-outcome
          :learning-unit="learningUnit"
          :disabled="disabled || learningUnit.is_published"
        ></tab-learning-outcome> -->

        <!-- <PublicationTabTodo
          :learning-unit="learningUnit"
          :default-section="defaultSection"
          :active="isTabActive('to-do-for-publication')"
          @fetch:success="onTabTodoFetchSuccess"
        /> -->

        <b-tab
          v-if="!learningUnit.is_published && learningUnit.latest_request_changes_at"
          title="Reviewer feedback"
          lazy
        >
          <div class="d-flex justify-content-center mb-5">
            <ReviewerFeedback :learning-unit="learningUnit" />
          </div>
        </b-tab>
      </b-tabs>
    </b-col>
  </b-row>
</template>

<script>
import { learningUnitInfoMixin } from '@/mixins/learningUnitInfoMixin';
import { userInfoMixin } from '@/mixins/userInfoMixin';
import LearningUnit from '@/models/LearningUnit';
import Section from '@/models/Section';
import MethodComponent from '@/models/MethodComponent';
import BaseBreadCrumb from '@/components/base-components/BaseBreadCrumb';
import LearningUnitHeader from '@/components/LearningUnit/LearningUnitHeader';
import PageSection from '../Section/PageSection';
// import TabLearningOutcome from './components/TabLearningOutcome';
import PageBasicInfo from '../BasicInfo/PageBasicInfo';
import PageInstructor from '../Instructor/PageInstructor';
import SubmitReviewButton from '../Publication/components/SubmitReviewButton';
import ApproveOrEditButton from '../LearningUnitReview/components/ApproveOrEditButton';
import ReviewerFeedback from '../Information/components/ReviewerFeedback';
import TabEvaluationAssessment from './components/TabEvaluationAssessment.vue';
import TabAssess from '../EvidenceSubmission/components/TabAssess.vue';
import TabAssignAssessor from '../EvidenceSubmission/components/TabAssignAssessor.vue';
import BaseTextEditorDisplay from '@/components/base-components/BaseTextEditorDisplay';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  components: {
    PageBasicInfo,
    PageSection,
    PageInstructor,
    BaseBreadCrumb,
    LearningUnitHeader,
    SubmitReviewButton,
    ApproveOrEditButton,
    // TabLearningOutcome,
    ReviewerFeedback,
    TabEvaluationAssessment,
    TabAssess,
    TabAssignAssessor,
    BaseTextEditorDisplay,
    FontAwesomeIcon
  },

  mixins: [userInfoMixin, learningUnitInfoMixin],
  props: {
    mode: {
      type: String,
      default: 'instructor'
    },

    disabled: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Object,
      default: () => {
        return {
          generalInfo: false,
          method: false,
          learning: false
        };
      }
    }
  },

  data() {
    return {
      tabIndex: null,
      isLoading: true,
      todos: null,
      conflicts: null,
      hasMethodComponent: false
    };
  },

  computed: {
    tabIndice() {
      let ownerTabs = this.isOwner
        ? ['submission-dashboard', 'assessors', 'assign-assessor']
        : ['assessors'];

      let tabs = [
        'basic-information',
        'evaluation-assessments',
        'sessions',
        ...ownerTabs,
        'assess'
      ];

      // if (this.$currentUser.canAccessLearn(this.learningUnitId)) {
      //   tabs.push("sessions");
      // }

      tabs = [
        ...tabs,
        // 'learning-outcomes',
        // "to-do-for-publication",
        'reviewer-feedback'
      ];

      return tabs;
    },

    currentTabName() {
      const { tab = 'basic-information' } = this.$route.query;

      return tab;
    },

    activeTab: {
      set(index) {
        let { query } = this.$route;

        const tabName = this.tabIndice[index];

        // Basic info is managed on the Catalog side.
        if (this.catalogOwnsInfoTabs && tabName === 'basic-information') {
          this.goToCatalogBasicInfo();
          return;
        }

        // Evaluation assessment is managed on the Catalog side.
        if (this.catalogOwnsInfoTabs && tabName === 'evaluation-assessments') {
          this.goToCatalogEvaluationAssessment();
          return;
        }

        if (query.tab != tabName) {
          this.$router.push({ query: { ...query, tab: tabName } });
        }
      },

      get() {
        const { currentTabName } = this;

        return this.getTabIndex(currentTabName);
      }
    },

    isMode() {
      return this.$route.query.mode ? this.$route.query.mode : this.mode;
    },

    breadcrumbs() {
      const { name, isMode } = this;

      return isMode == 'assessor'
        ? [
            {
              key: 'evaluate',
              name: 'Evaluate',
              to: {
                name: 'evaluate'
              }
            },
            {
              key: 'learning-unit-info',
              name,
              active: true
            }
          ]
        : [
            {
              key: this.isMode === 'instructor' ? 'design-and-planning' : 'review-learning-unit',
              name:
                this.isMode === 'instructor'
                  ? 'Design and planning'
                  : 'Review Submitted Micro-Credentials',
              to: {
                name: this.isMode === 'instructor' ? 'design-planning' : 'review-learning-unit'
              }
            },
            {
              key: 'learning-unit-info',
              name,
              active: true
            }
          ];
    },

    defaultSection() {
      return Section.query()
        .where('learning_unit_id', this.learningUnitId)
        .where('is_default', true)
        .first();
    },

    isAssessor() {
      return this.$currentUser.isAssessorOf(this.learningUnitId);
    },
    isOwner() {
      return this.$currentUser.isOwnerOf(this.learningUnitId);
    },

    /**
     * Basic info and Evaluation assessment live in the Catalog (Laravel) app for
     * designers and reviewers alike, so this page hands both tabs over instead of
     * mounting its own.
     *
     * Deliberately keyed on the page's mode rather than a global role check:
     * assessors also render this component, and the Catalog page rejects anyone
     * who is neither the owner nor a reviewer, so sending them there is a 403.
     */
    catalogOwnsInfoTabs() {
      return this.isOwner || this.isMode === 'reviewer';
    }
  },

  watch: {
    '$route.path': {
      immediate: true,
      handler: 'fetch'
    },

    currentTabName: {
      immediate: true,
      handler(currentTabName) {
        if (currentTabName === 'reviewer-feedback' && this.isMode === 'instructor') {
          this.setCookieViewFeedback();
        }
      }
    },

    learningUnit: {
      immediate: true,
      handler: function (newLearningUnit, oldLearningUnit) {
        if (newLearningUnit?.id !== oldLearningUnit?.id) {
          this.activeTabFeedback();
        }
      }
    }
  },

  created() {
    // Redirect before the learning unit fetch so it doesn't wait on the page to
    // load. This covers arriving by URL or bookmark; onActivateTab covers clicks.
    if (!this.catalogOwnsInfoTabs) {
      return;
    }

    if (this.currentTabName === 'basic-information') {
      this.goToCatalogBasicInfo();
    } else if (this.currentTabName === 'evaluation-assessments') {
      this.goToCatalogEvaluationAssessment();
    }
  },

  methods: {
    onActivateTab(newTabIndex, prevTabIndex, bvEvent) {
      // Cancel activation of Catalog-owned tabs so their Vue components never
      // mount; navigate straight to the Catalog instead.
      if (!this.catalogOwnsInfoTabs) {
        return;
      }

      const tabName = this.tabIndice[newTabIndex];

      if (tabName === 'basic-information') {
        bvEvent.preventDefault();
        this.goToCatalogBasicInfo();
      } else if (tabName === 'evaluation-assessments') {
        bvEvent.preventDefault();
        this.goToCatalogEvaluationAssessment();
      }
    },

    goToCatalogBasicInfo() {
      const baseUrl = process.env.VUE_APP_CATALOG_APP_URL;

      if (!baseUrl || !this.learningUnitId) {
        console.error('Missing Catalog base URL or learning unit ID');
        return;
      }

      const url = new URL(`/en/design-planning/${this.learningUnitId}`, baseUrl);
      url.searchParams.set('tab', 'basic-information');

      window.location.assign(url.toString());
    },

    goToCatalogEvaluationAssessment() {
      const baseUrl = process.env.VUE_APP_CATALOG_APP_URL;

      if (!baseUrl || !this.learningUnitId) {
        console.error('Missing Catalog base URL or learning unit ID');
        return;
      }

      const url = new URL(`/en/design-planning/${this.learningUnitId}`, baseUrl);
      url.searchParams.set('tab', 'evaluation-assessments');

      window.location.assign(url.toString());
    },

    getTabIndex(checkedTabName) {
      return this.tabIndice.findIndex((tabName) => tabName === checkedTabName);
    },

    setCookieViewFeedback() {
      const viewFeedback = this.$cookies.get('view_feedback');
      if (viewFeedback) {
        let obj = viewFeedback[this.learningUnit.id];
        if (obj) {
          const { latest_request_changes_at } = obj;

          if (
            new Date(latest_request_changes_at) <
            new Date(this.learningUnit.latest_request_changes_at)
          ) {
            this.$set(
              viewFeedback[this.learningUnit.id],
              'latest_request_changes_at',
              this.learningUnit.latest_request_changes_at
            );

            this.$cookies.set('view_feedback', viewFeedback);
          }
        } else {
          /*มี cookie แล้วแต่ยังไม่มีข้อมูล LU นี้ใน cookie view_feedback */
          this.$set(viewFeedback, this.learningUnit.id, {
            latest_request_changes_at: this.learningUnit.latest_request_changes_at
          });

          this.$cookies.set('view_feedback', viewFeedback);
        }
      } else {
        this.$cookies.set(
          'view_feedback',
          JSON.stringify({
            [this.learningUnit.id]: {
              latest_request_changes_at: this.learningUnit.latest_request_changes_at
            }
          })
        );
      }
    },

    activeTabFeedback() {
      if (this.learningUnit && this.isMode === 'instructor') {
        const reviewFeedbackTabIndex = this.getTabIndex('reviewer-feedback');

        if (this.learningUnit.latest_request_changes_at && !this.learningUnit.is_published) {
          this.activeTab = reviewFeedbackTabIndex;
        }
      }
    },

    isTabActive(tabName) {
      const { tab } = this.$route.query;

      return tab === tabName;
    },

    async fetch() {
      this.isLoading = true;

      LearningUnit.delete(this.learningUnitId);

      await LearningUnit.api().fetchByLearningUnitId(this.learningUnitId);

      await this.checkIfMethodComponentExists();

      if (
        this.isMode === 'instructor' &&
        this.learningUnit &&
        !this.learningUnit.canAccess(this.user.id)
      ) {
        this.$router.replace({ name: 'learning-unit' });
      }

      this.isLoading = false;
    },

    onTabTodoFetchSuccess({ todos = [], conflicts = [] } = {}) {
      this.todos = [...todos];
      this.conflicts = [...conflicts];
    },

    emitDeleteLearningOutcome() {
      this.fetch();
    },

    async checkIfMethodComponentExists() {
      const methodCount = await MethodComponent.api().countMethodComponents(this.learningUnitId);

      this.hasMethodComponent = Number.isInteger(methodCount) && methodCount > 0;
    }
  }
};
</script>

<style lang="scss" scoped></style>
